import { useMemo } from "react";

import { useTempLayerConditions } from "../../../../../hooks/layer/useTempLayerConditions";
import { useSelectFeaturesLayerName } from "../../../../../hooks/selectFeatures/useSelectFeaturesLayerName";

export const useSelectedFeaturesCondition = () => {
  const conditions = useTempLayerConditions(false);
  const [layerStatisticsLayerName] = useSelectFeaturesLayerName();

  return useMemo(() => {
    return conditions[layerStatisticsLayerName];
  }, [conditions[layerStatisticsLayerName]]);
};
